import ItemsTab from './ItemsTab'
import './ItemsTab.css'

export default ItemsTab